export const BASE_URL = process.env.VUE_APP_API_URL;

export const PKG_NAME = 'bustion';

export const PREFERENCES = {
    PREFER_DARK_MODE: 'PREFER_DARK_MODE',
};

export const TOKEN = 'TOKEN';

export const NOTIFICATION_TIMEOUT = 3000;
export const PROFILE = process.env.VUE_APP_PROFILE;
export const PROFILE_CONTENT = require(`@/${PROFILE}.json`)